export const DOMAIN = {
  AMON: 'Admin Money',
  AUTH: 'Authentication',
  B2C: 'B2C',
  CONSUMER_ENABLEMENT: 'Consumer Enablement',
  CUSTOMER_LENDING_PROFILE: 'Customer Lending Profile',
  CUSTOMER_RELATIONS: 'Customer Relations',
  FRONT: 'Frontend Platform',
  FUNNEL: 'Funnel',
  GET_MONEY: 'Get Money',
  IFC: 'IFC',
  KUESKI: 'Kueski',
  MOBILE: 'Mobile',
  PROFILE: 'Profile',
  WEB: 'Web',
};

export const FEATURE = {
  ACCOUNTS_MANAGEMENT: 'Accounts Management',
  APP: 'App',
  ASSET_LOAD: 'Asset Load',
  AUTHENTICATION: 'Authentication',
  CASH_INSTALLMENTS: 'Cash Installments',
  CONTACT_INFO: 'Contact Information',
  CREDIT_CAPACITY: 'Credit Capacity',
  DIRECT_DEBIT: 'Direct Debit',
  DIRECT_DEBIT_SANTANDER: 'Direct Debit Santander',
  DOMIC_SUBSCRIPTION: 'Domic Subscription',
  FEATURE_FLAGS: 'FeatureFlags',
  FUNNEL: 'Funnel',
  INSTORE_CONSUMER: 'InStore Consumer',
  LOGIN: 'Login',
  MULTI: 'Multiproduct',
  NOTIFICATIONS: 'Notifications',
  PROFILE: 'Profile',
  PROMOTION_CODE: 'Promotion Code',
  REFUNDS: 'Refunds',
  STRIPE: 'Stripe',
  TRANSACTIONS: 'Transactions',
  VERIFF: 'Veriff',
};

export const DATASOURCE = {
  BRAZE: 'Braze',
  CONEKTA: 'Conekta',
  IOVATION: 'iovation',
  OBSERVABILITY: 'Observability',
  STRIPE: 'Stripe',
};

export const EVENT = {
  ADD_ACCOUNT: 'add_account',
  CANCEL_APPLICATION: 'cancel_application',
  CARD_REGISTRATION: 'card_registration',
  CHECKTIMER_REQUEST: 'mobile_timer_request',
  CLICK_EDIT_BUTTON: 'click_edit_button',
  CONEKTA_CHECKOUT: 'checkout_creation',
  CONEKTA_CHECKOUT_REQUEST: 'checkout_request',
  CONEKTA_IFRAME: 'conekta_iframe',
  DELETE_CARD: 'get_cards',
  DOMIC_SUBSCRIPTION: 'domic_subscription',
  EDIT_OFFER: 'edit_offer',
  ERROR_DATASOURCE: 'error_datasource',
  FAILED_REDEMPTION: 'failed_redemption',
  FETCH_RESOURCE: 'fetch_resource',
  GET_BALANCE: 'get_balance',
  GET_CARD: 'get_cards',
  GET_CARD_DETAILS: 'get_card_details',
  GET_CONTACT_INFORMATION: 'get_contact_info',
  GET_DOCUMENTS_CONTRACTS: 'get_documents_pdf',
  GET_LOAN_SAVINGS: 'get_loan_savings',
  GET_MERCHANT: 'get_merchant',
  GET_MERCHANTS: 'get_merchants',
  GET_OFFER: 'get_offer',
  GET_PAYMENT_APP: 'get_payment_application',
  GET_QUESTIONNAIRE: 'get_questionnaire',
  GET_REFERENCES: 'get_references',
  GET_REQUIREMENTS: 'get_requirements',
  GET_SELECTED_CARD: 'get_selected_card',
  GET_STRIPE_KEY: 'get_stripe_key',
  GET_TOTALS: 'fetch_totals',
  LIST_ACCOUNTS: 'list_accounts',
  LOAD_SCRIPT: 'load_script',
  NOTIFICATIONS_SDK_INTEGRATION: 'notifications_sdk_integration',
  PAYMENT: 'payment',
  SANTANDER_PAYMENT_URL: 'get_payment_url',
  SAVED_DATASOURCE: 'saved_datasource',
  SELECT_OFFER: 'offer_select',
  SEND_DATASOURCE: 'send_datasource',
  SHOW_LOAN_ITEM_CARD: 'show_loan_item_card',
  SHOW_OFFER: 'show_offer',
  STRIPE_CREATE_PAYMENT_METHOD: 'stripeCreatePaymentMethod',
  STRIPE_REGISTER_CARD: 'stripeRegisterCard',
  SUCCESSFUL_REDEMPTION: 'successful_redemption',
  TRANSACTIONS_DETAIL: 'transactions_detail_open',
  TRANSACTIONS_FILTER: 'transactions_filter_changed',
  TRANSACTIONS_TAB: 'transactions_tab_open',
  UNLOAD_SCRIPT: 'unload_script',
  UPDATE_APP_CASH_INSTALLMENTS: 'update_app_cash_installments',
  UPDATE_REQUIREMENT_DOWNPAYMENT: 'update_requirement_downpayment',
  UPDATE_REQUIREMENT_SELECT_DEPOSIT_CARD: 'update_requirement_select_deposit_card',
  USER_ACCEPT_OFFER: 'accept_offering',
};
